import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, GridColumn } from 'semantic-ui-react'
import InputField from '../../../../commonComponents/formComponents/inputField'
import { updateTransportationHeaderInfo, updatearrivalTransportField } from '../../../actions'
import DropDown from '../../../../commonComponents/formComponents/dropDown'
import DeliveryTerms from './deliveryTerms'
import { AddDropdown } from '../../../../commonComponents/dropdown/AddDropdown'
import { useEvent } from '../../../hooks/useEvent'
import { showToast } from '../../../../commonComponents/showToast'
import GoodsLocationField from './locationOfGoods'
import { validation } from '../../../util/cdsFieldPatterns';
import {addHeaderTabWarnings,deleteHeaderTabWarnings} from "../../../actions/errorValidationActions";
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType'
import { dispCountry, destCountry, containerIndicator, 
  borderTransMode, natureOfTrans, custOfficeOfExit } from '../../../util/cdsFieldPattern'

const HeaderInfo1 = (props) => {
  const {serviceType} = useCurrentShipmentType()
  const dispatch = useDispatch()
  const { saveForm } = useEvent('header', true)
  const saveData = (params) => saveForm({ transportation: params })
  const transportModeTypes = useSelector((state) => state.DropDownValues?.transportModeTypes) || []
  const customsOffices = useSelector((state) => state.DropDownValues?.customsOffices) || []
  const customsOfficeOfExitValue = useSelector((state) => state.DropDownValues?.customsOfficeOfExit) || []
  const countryTypes = useSelector((state) => state.DropDownValues?.countryTypes) || []
  const {declarationCat = ''} = useSelector((state) => state.Shipment) || []
    
  const locationOfGoodsDropDownValues =
    useSelector((state) => state.DropDownValues?.locationOfGoods) || []

    const borderTransportNationalityDropDownValues =
    useSelector((state) => state.DropDownValues?.mop) || []
    
  const arrivalTransportIdTypeDropDownValues =
    useSelector((state) => state.DropDownValues?.transportIdType) || []
    
  const natureOfTransactionDropDownValues =
    useSelector((state) => state.DropDownValues?.natureOfTransaction) || []

    const transportChargesMOPDropDownValues =
    useSelector((state) => state.DropDownValues?.transportChargesMOP) || []


  const controlIndicatorDropdown = [
    { id: 0, text: 'YES', value: '1' },
    { id: 1, text: 'NO', value: '0' },
  ]
  const { 
    isFormDisabled = false,
    isImportShipment,
    fieldPattern,
    validateError
   } = props
  const {
    dispatchCountry,
    placeOfLoading,
    countryOfDestination,
    locationOfGoods,
    container,
    borderTransportNationality,
    inlandTransportMode,
    customsOfficeOfPresentation,
    supervisingCustomOffice,
    natureOfTransaction,
    finalDestinationTransportCost,
    idTransportType,
    idTransportNumber,
    transportChargesMop,
    customsOfficeOfExit
    
  } = useSelector((state) => state.Shipment.transportation)
  const { id, idType, idNumber, borderTransportMode } = useSelector(
    (state) => state.Shipment.transportation?.transport
  )

  
  const dispatchCountryErr = useSelector(state=>state.ValidationErrors?.header?.[dispCountry]?.msg)
  const countryOfDestinationErr = useSelector(state=>state.ValidationErrors?.header?.[destCountry]?.msg)
  const containerErr = useSelector(state=>state.ValidationErrors?.header?.[containerIndicator]?.msg)
  const borderTransportModeErr = useSelector(state=>state.ValidationErrors?.header?.[borderTransMode]?.msg)
  const natureOfTransactionErr = useSelector(state=>state.ValidationErrors?.header?.[natureOfTrans]?.msg)
  const customsOfficeOfExitErr = useSelector(state=>state.ValidationErrors?.header?.[custOfficeOfExit]?.msg)

   const getValidationError = React.useMemo(
     () => validation(declarationCat, 'headerTab'),
     [declarationCat]
   )

  const addErrors = (level, value, fieldName) => {
    dispatch(addHeaderTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteHeaderTabWarnings(level, value, fieldName))
  }


  const saveArrivalTransport = async (id, field, value) => {
    if (!id) {
      const response = await saveData({
        transport: {
          id: '',
          [field]: value||' ',
        },
      })
      if (!response) {
        showToast('Something went wrong, cannot save the value please try again !')
        return
      }
      const currentID = response?.header?.transportation?.transport?.id
      currentID && dispatch(updatearrivalTransportField({ fieldName: 'id', currentID }))
    } else {
      saveData({
        transport: {
          id: id,
          [field]: value|| ' ',
        },
      })
    }
  }
  return (
    <React.Fragment>
      <Grid.Row>
        <Grid.Column width={serviceType==="EX"?'6':'4'} className='divFormFeild'>
          <DropDown
            id='dispatchCountry'
            label='Dispatch Country'
            data={countryTypes}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='5/14'
            clearable
            value={dispatchCountry}
            errors={isImportShipment ? getValidationError("dispatchCountry",dispatchCountry,true) : dispatchCountryErr}
            onChange={(value) => {
              saveData({
                dispatchCountry: value||' ',
              })
              validateError({[`${dispCountry}`]:'',declarationCat:''},
              {transportation:{dispatchCountry:value},declarationCat:declarationCat},
              {[dispCountry]:fieldPattern()?.header[dispCountry],
                declarationCat:fieldPattern()?.header?.declarationCat})

              let err = getValidationError('dispatchCountry', value, 'headerTab',true)
                err.length
                  ? addErrors('headerTab', err[0], 'dispatchCountry')
                  : deleteErrors('headerTab', '', 'dispatchCountry')

              dispatch(updateTransportationHeaderInfo({ fieldName: 'dispatchCountry', value }))
            }}
          />
        </Grid.Column>
        {serviceType==="IM"&&
        <Grid.Column width='4' className='divFormFeild'>
          <AddDropdown
            id='placeOfLoading'
            label='Place of Loading'
            shipmentType={isImportShipment?'IMPORT':'EXPORT'}
            disabled={isFormDisabled || borderTransportMode !== '4'}
            className='field-bg dropdown100'
            boxNumber='5/21'
            country='UK-CDS'
            type='placeOfLoading'
            clearable
            onSelect={({ value }) => {
              saveData({
                placeOfLoading: value || ' ',
              })
              dispatch(updateTransportationHeaderInfo({ fieldName: 'placeOfLoading', value }))
            }}
            onBlur={({value})=>{
              if(!value?.trim()){
                saveData({
                  placeOfLoading: value || ' ',
                  
                })
              dispatch(updateTransportationHeaderInfo({ fieldName: 'placeOfLoading', value }))

              }
            }}
            selectedValue={placeOfLoading}
          />
        </Grid.Column>}
        <Grid.Column width={serviceType==="EX"?'6':'4'} className='divFormFeild'>
          <DropDown
            id='destinationCountry'
            label='Country of Destination'
            data={countryTypes}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='5/8'
            clearable
            value={countryOfDestination}
            errors={isImportShipment ? getValidationError("countryOfDestination",countryOfDestination,true) :countryOfDestinationErr}
            onChange={(value) => {
              saveData({
                countryOfDestination: value || ' ',
              })
              validateError({[`${destCountry}`]:''},
              {transportation:{countryOfDestination:value}},
              {[`${destCountry}`]:fieldPattern()?.header[destCountry]}) // M

              let err = getValidationError('countryOfDestination', value, 'headerTab',true)
                err.length
                  ? addErrors('headerTab', err[0], 'countryOfDestination')
                  : deleteErrors('headerTab', '', 'countryOfDestination')
              dispatch(updateTransportationHeaderInfo({ fieldName: 'countryOfDestination', value }))
            }}
          />
        </Grid.Column>

        <Grid.Column width='4' className='divFormFeild'>
          <GoodsLocationField 
            locationOfGoods={locationOfGoods}
            isImportShipment={isImportShipment}
            fieldPattern={fieldPattern}
            validateError={validateError}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width='4' className='divFormFeild'>
          {serviceType==="EX"?
          <DropDown
          id='departureTransport'
          label='Departure transport Type'
          disabled={isFormDisabled}
          className='field-bg dropdown100'
          boxNumber='7/7'
          clearable
          value={idType}
            data={arrivalTransportIdTypeDropDownValues}
            onChange={(value) => {
              saveArrivalTransport(id, 'idType', value)
              dispatch(updatearrivalTransportField({ fieldName: 'idType', value }))
              
            }}
        />
          :
          <DropDown
            id='arrivalTransport'
            label='Arrival transport Type'
            disabled={isFormDisabled}
            className='field-bg dropdown100 addInfoCode'
            boxNumber='7/9'
            clearable
            value={idType}
            data={arrivalTransportIdTypeDropDownValues}
            onChange={(value) => {
              saveArrivalTransport(id, 'idType', value)
              dispatch(updatearrivalTransportField({ fieldName: 'idType', value }))
              
            }}
          />}
        </Grid.Column>
        <Grid.Column width='4' className='divFormFeild'>
          {serviceType==="EX"?
          <InputField
          isLabel={false}
          id='transportNo'
          type='text'
          mandatory={false}
          boxNumber='7/7'
          label='Departure transport Number'
          value={idNumber}
          className={'field-bg'}
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) => {
            saveArrivalTransport(id, 'idNumber', value)
            dispatch(updatearrivalTransportField({ fieldName: 'idNumber', value }))
                      }}
        />
          :
          <InputField
            isLabel={false}
            id='transportNo'
            type='text'
            mandatory={false}
            boxNumber='7/9'
            label='Arrival transport Number'
            value={idNumber}
            errors={getValidationError("arrivalTransportIDNumber",idNumber)}
            className={'field-bg'}
            clearInput={false}
            disabled={isFormDisabled}
            onChange={(value) => {
              saveArrivalTransport(id, 'idNumber', value)
              dispatch(updatearrivalTransportField({ fieldName: 'idNumber', value }))
              let err = getValidationError('arrivalTransportIDNumber', value, 'headerTab')
              err.length
                  ? addErrors('headerTab', err[0], 'arrivalTransportIDNumber')
                  : deleteErrors('headerTab', '', 'arrivalTransportIDNumber')
            }}
          />}
        </Grid.Column>
        <Grid.Column width='8' className='divFormFeild'>
          <DropDown
            id='containerIndicator'
            label='Container Indicator'
            data={controlIndicatorDropdown}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='7/2'
            clearable
            value={container}
            errors={isImportShipment ? getValidationError("container",container,true) : containerErr}
            onChange={(value) => {
              saveData({
                container: value,
              })
              validateError({[`${containerIndicator}`]:'',declarationCat:''},
                {transportation:{container:value}, declarationCat:declarationCat},
                {[`${containerIndicator}`]:fieldPattern()?.header[containerIndicator],declarationCat:fieldPattern()?.header[declarationCat]}
              )
              dispatch(updateTransportationHeaderInfo({ fieldName: 'container', value }))
              let err = getValidationError('container', value, 'headerTab',true)
              err.length
                  ? addErrors('headerTab', err[0], 'container')
                  : deleteErrors('headerTab', '', 'container')
            }}
          />
          {/* <InputField
            isLabel={false}
            id='container'
            type='text'
            mandatory={false}
            boxNumber='7/2'
            label='Container Indicator'
            value={container}
            //value={formData.carrierName}
            className={'field-bg'}
            clearInput={false}
            disabled={isFormDisabled}
            onChange={(value) => {
              dispatch(updateTransportationHeaderInfo({ fieldName: 'container', value }))
            }}
            onBlur={(value) => {
              saveData({
                container: value,
              })
            }}
          /> */}
        </Grid.Column>
      </Grid.Row>
      {serviceType==="EX"&&
      <Grid.Row>
        <Grid.Column width='5' className='divFormFeild'>
        <DropDown
            id='activeMeansOfTransportType'
            label='IDENTITY OF MEANS OF TRANSPORT TYPE'
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='7/14'
            clearable
            value={idTransportType}
            data={arrivalTransportIdTypeDropDownValues}
            onChange={(value) => {
              saveData({
                idTransportType: value || ' ',
              })
              dispatch(updateTransportationHeaderInfo({ fieldName: 'idTransportType', value }))
              
            }}
          />
                    {/* <InputField
            isLabel={false}
            id='activeMeansOfTransportType'
            type='text'
            mandatory={false}
            boxNumber='7/14'
            label='IDENTITY OF MEANS OF TRANSPORT TYPE'
            className={'field-bg'}
            value={idTransportType}
            clearInput={false}
            disabled={isFormDisabled}
            onChange={(value) => {
              dispatch(
                updateTransportationHeaderInfo({
                  fieldName: 'idTransportType',
                  value,
                })
              )
            }}
            onBlur={(value) => {
              saveData({
                idTransportType: value||' ',
              })
            }}
          /> */}

          </Grid.Column>
          <Grid.Column width='5' className='divFormFeild'>
          
          <InputField
            isLabel={false}
            id='activeMeansOfTransportNumber'
            type='text'
            mandatory={false}
            boxNumber='7/14'
            label='IDENTITY OF MEANS OF TRANSPORT NUMBER'
            className={'field-bg'}
            value={idTransportNumber}
            clearInput={false}
            disabled={isFormDisabled}
            onChange={(value) => {
              dispatch(
                updateTransportationHeaderInfo({
                  fieldName: 'idTransportNumber',
                  value,
                })
              )
            }}
            onBlur={(value) => {
              saveData({
                idTransportNumber: value||' ',
              })
            }}
          />
          </Grid.Column>
          <Grid.Column width='6' className='divFormFeild'>
          <DropDown
            id='transportChargesMop'
            label='TRANSPORT CHARGES MOP'
            data={transportChargesMOPDropDownValues}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='4/2'
            clearable
            value={transportChargesMop}
            onChange={(value) => {
              saveData({
                transportChargesMop: value || ' ',
              })
              dispatch(updateTransportationHeaderInfo({ fieldName: 'transportChargesMop', value }))
              
            }}
          />
            </Grid.Column> 


      </Grid.Row>}

      <Grid.Row>
        <Grid.Column width='5' className='divFormFeild'>
          <DropDown
            id='borderTransportNationality'
            label='Border Transport Nationality'
            data={countryTypes}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='7/15'
            clearable
            value={borderTransportNationality}
            onChange={(value) => {
              saveData({
                borderTransportNationality: value,
              })
              dispatch(
                updateTransportationHeaderInfo({ fieldName: 'borderTransportNationality', value })
              )
              
            }}
          />
        </Grid.Column>
        <Grid.Column width='5' className='divFormFeild'>
          <DropDown
            id='borderTransportMode'
            label='Border Transport Mode '
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='7/4'
            clearable
            data={transportModeTypes}
            value={borderTransportMode}
            errors={isImportShipment ? getValidationError("borderTransportMode",borderTransportMode,true):borderTransportModeErr}
            onChange={(value) => {
            
              if(value!='4'){
                saveData({
                  placeOfLoading: ' ',
                })
                dispatch(updateTransportationHeaderInfo({ fieldName: 'placeOfLoading', value:' ' }))
              }

              validateError({[`${borderTransMode}`]:'',declarationCat:''},
              {transportation:{transport:{borderTransportMode:value}}, declarationCat:declarationCat},
              {[`${borderTransMode}`]:fieldPattern()?.header[borderTransMode],declarationCat:fieldPattern()?.header[declarationCat]})
                          
              saveArrivalTransport(id, 'borderTransportMode', value)
              dispatch(updatearrivalTransportField({ fieldName: 'borderTransportMode', value }))
              let err = getValidationError('borderTransportMode', value, 'headerTab',true)
              err.length
                  ? addErrors('headerTab', err[0], 'borderTransportMode')
                  : deleteErrors('headerTab', '', 'borderTransportMode')
            }}
          />
        </Grid.Column>
        <Grid.Column width='6' className='divFormFeild'>
          <DropDown
            id='inlandTransportMode'
            label='Inland Transport Mode '
            data={transportModeTypes}
            disabled={isFormDisabled}
            value={inlandTransportMode}
            className='field-bg dropdown100'
            boxNumber='7/5'
            clearable
            onChange={(value) => {
              saveData({
                inlandTransportMode: value ||' ',
              })
              dispatch(updateTransportationHeaderInfo({ fieldName: 'inlandTransportMode', value }))
            }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width='5' className='divFormFeild'>
          <DropDown
            id='customOfficePresentation'
            label='Custom Office of presentation'
            data={customsOffices}
            disabled={isFormDisabled}
            value={customsOfficeOfPresentation}
            className='field-bg dropdown100'
            boxNumber='5/26'
            clearable
            onChange={(value) => {
              saveData({
                customsOfficeOfPresentation: value || ' ',
              })
              dispatch(
                updateTransportationHeaderInfo({ fieldName: 'customsOfficeOfPresentation', value })
              )
            }}
          />
        </Grid.Column>
        <Grid.Column width='5' className='divFormFeild'>
          <DropDown
            id='supervising'
            label='supervising customs office'
            data={customsOffices}
            value={supervisingCustomOffice}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='5/27'
            clearable
            onChange={(value) => {
              saveData({
                supervisingCustomOffice: value || ' ',
              })
              dispatch(
                updateTransportationHeaderInfo({ fieldName: 'supervisingCustomOffice', value })
              )
            }}
          />
        </Grid.Column>
        <Grid.Column width='6' className='divFormFeild'>
          <DropDown
            id='natureOfTransaction'
            label='Nature of transaction'
            data={natureOfTransactionDropDownValues}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='8/5'
            clearable
            value={natureOfTransaction}
            errors={isImportShipment ? getValidationError("natureOfTransaction",natureOfTransaction,true): natureOfTransactionErr}
            onChange={(value) => {
              saveData({
                natureOfTransaction: value || ' ',
              })
              dispatch(updateTransportationHeaderInfo({ fieldName: 'natureOfTransaction', value }))

              validateError({[`${natureOfTrans}`]:'',declarationCat:''},
              {transportation:{natureOfTransaction:value}, declarationCat:declarationCat},
              {[`${natureOfTrans}`]:fieldPattern()?.header[natureOfTrans],declarationCat:fieldPattern()?.header[declarationCat]})

              let err = getValidationError('natureOfTransaction', value, 'headerTab',true)
              err.length
                  ? addErrors('headerTab', err[0], 'natureOfTransaction')
                  : deleteErrors('headerTab', '', 'natureOfTransaction')
            }}
          />
        </Grid.Column>
      </Grid.Row>
      {serviceType==="EX"&&
      <Grid.Row>
      <Grid.Column width='16' className='divFormFeild'>
          <DropDown
            id='customsOfficeofExit'
            label='CUSTOMS OFFICE OF EXIT'
            data={customsOfficeOfExitValue}
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            boxNumber='5/12'
            clearable
            errors={!isImportShipment && customsOfficeOfExitErr}
            value={customsOfficeOfExit}
              onChange={(value) => {
              saveData({
                customsOfficeOfExit: value || ' ',
              })

              validateError({[`${custOfficeOfExit}`]:'',declarationCat:''},
              {transportation:{customsOfficeOfExit:value},declarationCat:declarationCat},
              {[`${custOfficeOfExit}`]:fieldPattern()?.header[custOfficeOfExit],declarationCat:fieldPattern()?.header.declarationCat})

              dispatch(
                updateTransportationHeaderInfo({ fieldName: 'customsOfficeOfExit', value })
              )
            }}
            />
            </Grid.Column>
            {/* <Grid.Column width='8' className='divFormFeild'>
          <DropDown
            id='countriesofroutingcodes'
            label='COUNTRIES OF ROUTING CODES'
            data={natureOfTransactionDropDownValues}
            disabled={true}
            className='field-bg dropdown100'
            boxNumber='5/18'
            clearable
            value={natureOfTransaction}
            />
            </Grid.Column> */}
      </Grid.Row>}
      <DeliveryTerms />
      {serviceType==="IM"&&
      <Grid.Row>
        <Grid.Column width='8' className='divFormFeild b-bw-1'>
          <InputField
            isLabel={false}
            id='finalDestinationTransportCost'
            type='text'
            mandatory={false}
            boxNumber='4/19'
            label='Final Destination Transport Cost'
            className={'field-bg'}
            value={finalDestinationTransportCost}
            clearInput={false}
            disabled={isFormDisabled}
            onChange={(value) => {
              dispatch(
                updateTransportationHeaderInfo({
                  fieldName: 'finalDestinationTransportCost',
                  value,
                })
              )
            }}
            onBlur={(value) => {
              saveData({
                finalDestinationTransportCost: value||' ',
              })
            }}
          />
        </Grid.Column>
      </Grid.Row>}
    </React.Fragment>
  )
}

export default React.memo(HeaderInfo1)
